<ng-container *ngIf="gatewayStore.assignableDevicesFlag$ | async as flag">
  <div
    *ngIf="gatewayStore.assignableDevices$ | async as assignableDevices"
    class="flex flex-col gap-[24px]"
  >
    <div class="flex flex-row justify-between items-center">
      <div class="flex flex-row gap-[24px] lt-md:gap-[16px] justify-start items-center">
        <mat-icon>menu</mat-icon>
        <h3 class="app-ellipsis">
          {{ deviceGroup?.devices[0]?.roles | translateDeviceByRoles }}
        </h3>
      </div>
    </div>

    <div *ngIf="deviceGroup.devices.length" class="offset src-devices-grid">
      <app-src-device-panel
        *ngFor="let device of deviceGroup.devices"
        [device]="device"
        [heatingCircuitIdFeature$]="heatingCircuitId$[device.id]"
        [isDeleteable]="true"
      ></app-src-device-panel>
    </div>
  </div>
</ng-container>
